import ePin from "modules/ePin";

import { NAME, RESET_PASSWORD_FORM } from "./constants";

export const ActivateAccount = ePin({
    actionPrefix: `${NAME}/activateAccount`,
    reducerPath: [NAME, "appState", "activateAccount"],
    formPrefix: RESET_PASSWORD_FORM,
});
